import React from "react";
import { IconProps } from "./IconProps";

const ShareIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 15.5H3.12L3 15.38V6C3 5.72 2.78 5.5 2.5 5.5C2.22 5.5 2 5.72 2 6V15.38C2 15.68 2.12 15.96 2.33 16.18C2.54 16.39 2.83 16.51 3.13 16.51H15.01C15.29 16.51 15.51 16.29 15.51 16.01C15.51 15.73 15.29 15.51 15.01 15.51L15 15.5Z"
            fill={color}
          />
          <path
            d="M17.85 6.9L14.1 3.15C13.9 2.95 13.59 2.95 13.39 3.15C13.19 3.35 13.19 3.66 13.39 3.86L16.29 6.76H12.88C11.12 6.76 9.38001 7.35 7.98001 8.43C6.58001 9.51 5.57001 11.05 5.13001 12.76C5.06001 13.03 5.22001 13.3 5.49001 13.37C5.53001 13.38 5.57001 13.39 5.62001 13.39C5.84001 13.39 6.05001 13.24 6.10001 13.01C6.49001 11.51 7.37001 10.17 8.59001 9.22C9.81001 8.28 11.33 7.76 12.88 7.76H16.29L13.39 10.66C13.19 10.86 13.19 11.17 13.39 11.37C13.49 11.47 13.62 11.52 13.74 11.52C13.86 11.52 14 11.47 14.09 11.37L17.84 7.62C18.04 7.42 18.04 7.11 17.84 6.91L17.85 6.9Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.28 12.2613L22.28 18.2613C22.1378 18.3938 21.9498 18.4659 21.7555 18.4625C21.5612 18.459 21.3758 18.3803 21.2384 18.2429C21.101 18.1055 21.0223 17.9201 21.0188 17.7258C21.0154 17.5315 21.0875 17.3435 21.22 17.2013L25.9387 12.4813H20.375C17.88 12.4792 15.4552 13.3072 13.4825 14.8347C11.5098 16.3623 10.1013 18.5027 9.47875 20.9188C9.42902 21.1114 9.30481 21.2764 9.13345 21.3774C8.96209 21.4784 8.75761 21.5073 8.565 21.4575C8.37239 21.4078 8.20742 21.2836 8.10638 21.1122C8.00535 20.9409 7.97652 20.7364 8.02625 20.5438C8.73189 17.8057 10.3282 15.3801 12.5638 13.6489C14.7995 11.9176 17.5474 10.9792 20.375 10.9813H25.9412L21.22 6.26129C21.0875 6.11912 21.0154 5.93107 21.0188 5.73677C21.0223 5.54247 21.101 5.35708 21.2384 5.21967C21.3758 5.08226 21.5612 5.00355 21.7555 5.00012C21.9498 4.99669 22.1378 5.06881 22.28 5.20129L28.28 11.2013C28.4205 11.3419 28.4993 11.5325 28.4993 11.7313C28.4993 11.93 28.4205 12.1207 28.28 12.2613ZM23.75 24.9813H4.75C4.6837 24.9813 4.62011 24.955 4.57322 24.9081C4.52634 24.8612 4.5 24.7976 4.5 24.7313V9.73129C4.5 9.53238 4.42098 9.34161 4.28033 9.20096C4.13968 9.06031 3.94891 8.98129 3.75 8.98129C3.55109 8.98129 3.36032 9.06031 3.21967 9.20096C3.07902 9.34161 3 9.53238 3 9.73129V24.7313C3 25.1954 3.18437 25.6405 3.51256 25.9687C3.84075 26.2969 4.28587 26.4813 4.75 26.4813H23.75C23.9489 26.4813 24.1397 26.4023 24.2803 26.2616C24.421 26.121 24.5 25.9302 24.5 25.7313C24.5 25.5324 24.421 25.3416 24.2803 25.201C24.1397 25.0603 23.9489 24.9813 23.75 24.9813Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ShareIcon;
